import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
  onClose: (isConfirmed: boolean) => void
};

export default function DeleteUserConfirmationDialog({ onClose }: Props) {
  const [confirmText, setConfirmText] = useState('')

  return (
    <Dialog open={true} maxWidth={'xs'} onClose={() => onClose(false)}>
      <DialogTitle>
        Confirm Delete Action
      </DialogTitle>
      <DialogContent dividers sx={ styles.content }>
        <Typography variant="subtitle2">Are you sure that you want to <strong>DELETE</strong> account? This action is permanent and is not reversable. All user data, including bands and songs, will be removed.</Typography>
        <Typography variant="subtitle2">Please type "delete" in textbox below.</Typography>
        <TextField fullWidth variant="outlined" placeholder="delete" onChange={
          (event: React.ChangeEvent<HTMLInputElement>) => {
            setConfirmText(event.target.value);
          }
        }/>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          sx={styles.button}
          disabled={confirmText !== 'delete'}
          onClick={() => onClose(true)}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  button: {
    width: 100,
    color: "#fff"
  }
};
